export enum EAssistantSharePermission {
  VIEWER = "viewer",
  EDITOR = "editor",
}

export interface IAssistantShare {
  uuid: string;
  assistantUuid: string;
  userUuid: string;
  userFirstName: string | null;
  userLastName: string | null;
  userEmail: string | null;
  // NOTE: NSAI-7736 — the IdP login name of a person with no email.
  userUsername?: string | null;
  permissionLevel: EAssistantSharePermission;
  sharedByUuid: string;
  sharedByFirstName: string | null;
  sharedByLastName: string | null;
  createdAt: string;
}

export interface IAssistantSharesListResponse {
  shares: IAssistantShare[];
  totalCount: number;
}

export interface IShareAssistantItem {
  userUuid: string;
  permissionLevel?: EAssistantSharePermission;
}

export interface IShareAssistantPayload {
  shares: IShareAssistantItem[];
}

export interface IUpdateAssistantSharePayload {
  permissionLevel: EAssistantSharePermission;
}

export interface IGetUserInitialsProps {
  firstName: string | null;
  lastName: string | null;
}

export interface IGetUserDisplayNameProps {
  firstName: string | null;
  lastName: string | null;
}
